import {
  Collapse,
  Icon,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useMemo, useState } from "react";
import { EOptionType } from "../../../../../../../interfaces/enums";
import { isFilterAndValueSelected } from "../../../../../../../lib/filters";
import { useAppSelector } from "../../../../../../../store/hooks";
import { IFilterProps } from "../../interfaces";

function ClientiFilter({ filters, setFilters }: IFilterProps) {
  const [open, setOpen] = useState<boolean>(false);

  const dettaglioItems = useAppSelector(
    (state) => state.dettaglio.soldItems ?? {}
  );

  const clienti: string[] = useMemo(() => {
    const clientiArray = Object.values(dettaglioItems)
      .map((dettaglio) => dettaglio.opzCliente as string)
      .filter(Boolean);
    const clientiSet = new Set(clientiArray);
    const clienti = Array.from(clientiSet);
    clienti.sort((a, b) => (a > b ? 1 : -1));
    return clienti;
  }, [dettaglioItems]);

  const toggle = () => {
    setOpen(!open);
  };

  const toggleSelected = (item: string) => {
    if (isFilterAndValueSelected(filters, EOptionType.cliente, item)) {
      setFilters(
        filters.filter(
          (opt) =>
            !(opt.type === EOptionType.cliente && opt.stringValue === item)
        )
      );
    } else {
      setFilters([
        ...filters,
        {
          type: EOptionType.cliente,
          stringValue: item,
        },
      ]);
    }
  };

  return (
    <>
      <ListItemButton onClick={toggle}>
        <ListItemIcon>
          <Icon className="fa-light fa-users" sx={{ overflow: "visible" }} />
        </ListItemIcon>
        <ListItemText primary="Clienti Opzionati" />
        {open ? (
          <Icon
            className="fa-light fa-angle-up"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        ) : (
          <Icon
            className="fa-light fa-angle-down"
            fontSize="small"
            sx={{ overflow: "visible" }}
          />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List dense={true}>
          {clienti.map((item) => (
            <ListItemButton
              key={item}
              sx={{ display: "flex", pl: 5, pr: 1 }}
              onClick={() => toggleSelected(item)}
              selected={isFilterAndValueSelected(
                filters,
                EOptionType.cliente,
                item
              )}
            >
              <ListItemText sx={{ flex: 1 }} primary={item} />
              <ListItemIcon sx={{ minWidth: 0 }}>
                {isFilterAndValueSelected(
                  filters,
                  EOptionType.cliente,
                  item
                ) && (
                  <Icon
                    className="fa-light fa-check"
                    sx={{ overflow: "visible" }}
                  />
                )}
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
}

export default ClientiFilter;
